import SwiperCore, { Navigation } from 'swiper/core';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/swiper.min.css';

SwiperCore.use([Navigation]);
